/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum PagesPermissions {
  banks = 'manageBanks',
  commoditiesForwardCurves = 'commodity_forward_curve_widget',
  commodityMarketData = 'commodity_forward_curve_widget',
  companyCenter = 'companyPage',
  complianceCentre = 'fund_level_compliance_access',
  deals = 'gold_vision',
  dealsManagement = 'deals_management',
  entityPortfolio = 'companyEntityPage',
  fundLevelAdmin = 'fund_module_admin_page',
  cdsWidget = 'cds_widget',
  discountFactors = 'DCFX_widget',
  foreignExchangeAnalysis = 'buildFxAnalysis',
  fxForwardCurves = 'buildFXForwardRates',
  fxOptionVolatility = 'buildFxOptionVols',
  hairyChart = 'hairy_chart',
  hedgeAccounting = 'manage_hedge_accounting',
  historicalForwardCurves = 'buildHistoForwardCurves',
  historicalIrDifferentialByCurrency = 'ir_differential_widget',
  interestCostCalculation = 'build_rfr_report',
  irAnalysis = 'interest_rate_analysis',
  irCapletVolatility = 'buildIrCapletVol',
  irDifferentialByCurrency = 'ir_differential_widget',
  irForwardCurves = 'buildForwardCurves',
  irMarketData = 'buildIrAnalysis',
  fxMarketData = 'buildFxAnalysis',
  journalEntries = 'manage_journal_entries',
  marketUpdateReport = 'ir_market_environment_report',
  correlatedMarketDataSimulations = 'ir_differential_widget',
  irPricer = 'insertSwapTrade',
  customPricer = 'insertSwapTrade',
  fxPricer = 'insertFxVanillaTrade',
  inflationPricer = 'inflationSwapPage',
  commodityPricer = 'commodity_pricer_access',
  debtPricer = 'Debt Pricer',
  reportCenter = 'reportCenter',
  riskManagementAnalysis = 'risk_mgm_analysis',
  runDeliverables = 'run_deliverables_page',
  scheduledDeliverables = 'scheduled_deliverables_page',
  securityDataDownload = 'sec_data_download',
  tradeCenter = 'trades_page',
  tradeNotification = 'trade_notification_page',
  transactionDetail = 'transactionDetail',
  users = 'manageUsers',
  userProfileAdminSection = 'userProfileAdminSection',
  resetPassword = 'resetPassword',
  createNewUser = 'addUser',
  userProfile = 'userProfile',
  settlements = 'view_settlements_history',
  sponsorPage = 'sponsorPage',
  transactionRollingTool = 'manage_fx_rolls',
  fxAnalysis = 'fx_analysis',
  exposureCapture = 'exposure_capture_page',
  exposureCalculation = 'exposure_calculation_page',
  marketDataCurvesPage = 'marketDataCurvesPage',
  marketDataWidgetsPage = 'marketDataWidgetsPage',
  transactionCostAnalysis = 'TransactionCostAnalysis',
  haAdministration = 'HAAdministrationPage',
  flCashConsumption = 'CashConsumptionAnalysis',
  HAOperationalDashboard = 'HAOperationalDashboard',
  sponsorDashboardAIChat = 'SponsorDashboardAIChat',
  tradeAIChatBuilder = 'tradeAIChatBuilder',
  tradeAIConfirmRead = 'tradeAIConfirmRead',
  manageAccessControl = 'manageAccessControl',
  clientApiDocs = 'ClientAPIDocs',
  marketDataPricing = 'marketDataPricing',
  buildFXForwardRates = 'buildFXForwardRates',
  bdIntelligenceHub = 'bdIntelligenceHub',
  marketDataAI = 'marketDataAI',
}
